// extracted by css-extract-rspack-plugin
export default {"cls1":"StickyWorkCardHeader-cls1_0rm","cls2":"StickyWorkCardHeader-cls2_An_ StickyWorkCardHeader-cls1_0rm","hidden":"StickyWorkCardHeader-hidden_XO6"};